// @ts-nocheck
import { apiRequest } from '../api/client'

export const MARKETPLACES_STATUS_CACHE_KEY = 'marketplaces-status'

export const getMarketplacesStatus = async (token, signal) =>
  apiRequest('/api/marketplaces/status', {
    token,
    signal,
    cacheKey: MARKETPLACES_STATUS_CACHE_KEY,
    cacheTtlMs: 15000,
    skipGlobalLoading: true,
  })
